'use strict';

var _extends = require('../../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var CircularProgress$1 = require('../../../Feedback/Progress/CircularProgress.js');
var withStyles = require('../../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var progressSizeTranslations = {
  small: 18,
  medium: 20,
  large: 24
};

var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      top: '50%',
      left: '50%'
    }
  };
};

var ButtonCircularProgress = function ButtonCircularProgress(_ref) {
  var size = _ref.size,
      restOfProps = objectWithoutProperties(_ref, ["size"]);

  var _ref2 = progressSizeTranslations || {},
      progressSize = _ref2[size]; // TODO: V4 will allow us to move this into the styles object


  var circularProgressInlineStyle = {
    marginTop: -(progressSize / 2),
    marginLeft: -(progressSize / 2)
  };
  return React__default["default"].createElement(CircularProgress$1, _extends["default"]({
    style: circularProgressInlineStyle,
    size: progressSize
  }, restOfProps));
};

var CircularProgress = withStyles(styles)(ButtonCircularProgress);

module.exports = CircularProgress;
